"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["title"];
const _hoisted_2 = { class: "gen-text" };
const _hoisted_3 = { class: "gen-marker" };
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "global_params" };
const _hoisted_6 = ["title"];
const _hoisted_7 = ["title"];
const _hoisted_8 = ["title"];
const _hoisted_9 = ["title"];
const _hoisted_10 = { class: "sidebar_item goto-cards sidebar_item_shortcut-long" };
const _hoisted_11 = { class: "sidebar_icon sidebar_icon--cards" };
const _hoisted_12 = { class: "deck-size" };
const _hoisted_13 = ["title"];
const _hoisted_14 = ["title"];
const _hoisted_15 = ["title"];
const _hoisted_16 = {
    key: 0,
    class: "info_panel"
};
const _hoisted_17 = { class: "info-panel-title" };
const _hoisted_18 = { class: "info_panel_actions" };
const _hoisted_19 = {
    href: "help",
    target: "_blank"
};
const _hoisted_20 = { class: "sidebar_item sidebar_item--help" };
const _hoisted_21 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_global_parameter_value = (0, vue_1.resolveComponent)("global-parameter-value");
    const _component_MoonGlobalParameterValue = (0, vue_1.resolveComponent)("MoonGlobalParameterValue");
    const _component_language_icon = (0, vue_1.resolveComponent)("language-icon");
    const _component_game_setup_detail = (0, vue_1.resolveComponent)("game-setup-detail");
    const _component_preferences_icon = (0, vue_1.resolveComponent)("preferences-icon");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)('sidebar_cont sidebar ' + _ctx.getSideBarClass())
    }, [
        (0, vue_1.createElementVNode)("div", {
            class: "tm",
            title: _ctx.$t('Generation Marker')
        }, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
                    (0, vue_1.createTextVNode)("GEN", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.getGenMarker()), 1)
        ], 8, _hoisted_1),
        (_ctx.gameOptions.expansions.turmoil)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 0,
                title: _ctx.$t('Ruling Party')
            }, [
                (0, vue_1.createElementVNode)("div", {
                    class: (0, vue_1.normalizeClass)('party-name party-name-indicator party-name--' + _ctx.rulingPartyToCss())
                }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getRulingParty()), 1)
                    ])), [
                        [_directive_i18n]
                    ])
                ], 2)
            ], 8, _hoisted_4))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_5, [
            (0, vue_1.createVNode)(_component_global_parameter_value, {
                param: _ctx.globalParameter.TEMPERATURE,
                value: _ctx.temperature
            }, null, 8, ["param", "value"]),
            (0, vue_1.createVNode)(_component_global_parameter_value, {
                param: _ctx.globalParameter.OXYGEN,
                value: _ctx.oxygen
            }, null, 8, ["param", "value"]),
            (0, vue_1.createVNode)(_component_global_parameter_value, {
                param: _ctx.globalParameter.OCEANS,
                value: _ctx.oceans
            }, null, 8, ["param", "value"]),
            (_ctx.gameOptions.expansions.venus)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_global_parameter_value, {
                    key: 0,
                    param: _ctx.globalParameter.VENUS,
                    value: _ctx.venus
                }, null, 8, ["param", "value"]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.moonData)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_MoonGlobalParameterValue, {
                    key: 1,
                    moonData: _ctx.moonData
                }, null, 8, ["moonData"]))
                : (0, vue_1.createCommentVNode)("", true)
        ]),
        (0, vue_1.createElementVNode)("div", {
            class: "sidebar_item preferences_player",
            title: _ctx.$t('Player Color Cube')
        }, [
            (0, vue_1.createElementVNode)("div", {
                class: (0, vue_1.normalizeClass)(_ctx.getPlayerColorCubeClass() + ' player_bg_color_' + _ctx.player_color)
            }, null, 2)
        ], 8, _hoisted_6),
        (0, vue_1.createElementVNode)("a", {
            href: "#board",
            title: _ctx.$t('Jump to board')
        }, [...(_cache[3] || (_cache[3] = [
                (0, vue_1.createElementVNode)("div", { class: "sidebar_item sidebar_item_shortcut" }, [
                    (0, vue_1.createElementVNode)("i", { class: "sidebar_icon sidebar_icon--board" })
                ], -1)
            ]))], 8, _hoisted_7),
        (0, vue_1.createElementVNode)("a", {
            href: "#actions",
            title: _ctx.$t('Jump to actions')
        }, [...(_cache[4] || (_cache[4] = [
                (0, vue_1.createElementVNode)("div", { class: "sidebar_item sidebar_item_shortcut" }, [
                    (0, vue_1.createElementVNode)("i", { class: "sidebar_icon sidebar_icon--actions" })
                ], -1)
            ]))], 8, _hoisted_8),
        (0, vue_1.createElementVNode)("a", {
            href: "#cards",
            title: _ctx.$t('Jump to cards')
        }, [
            (0, vue_1.createElementVNode)("div", _hoisted_10, [
                (0, vue_1.createElementVNode)("i", _hoisted_11, [
                    (0, vue_1.createElementVNode)("div", _hoisted_12, [
                        (0, vue_1.createTextVNode)("🂠" + (0, vue_1.toDisplayString)(_ctx.deckSize), 1),
                        _cache[5] || (_cache[5] = (0, vue_1.createElementVNode)("br", null, null, -1)),
                        (0, vue_1.createTextVNode)("🗑" + (0, vue_1.toDisplayString)(_ctx.discardPileSize), 1)
                    ])
                ])
            ])
        ], 8, _hoisted_9),
        (_ctx.coloniesCount > 0)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                key: 1,
                href: "#colonies",
                title: _ctx.$t('Jump to colonies')
            }, [...(_cache[6] || (_cache[6] = [
                    (0, vue_1.createElementVNode)("div", { class: "sidebar_item sidebar_item_shortcut" }, [
                        (0, vue_1.createElementVNode)("i", { class: "sidebar_icon sidebar_icon--colonies" })
                    ], -1)
                ]))], 8, _hoisted_13))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_language_icon),
        (0, vue_1.createElementVNode)("div", {
            class: "sidebar_item sidebar_item--info",
            title: _ctx.$t('Information panel')
        }, [
            (0, vue_1.createElementVNode)("i", {
                class: (0, vue_1.normalizeClass)(["sidebar_icon sidebar_icon--info", { 'sidebar_item--is-active': _ctx.ui.gamesetup_detail_open }]),
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.ui.gamesetup_detail_open = !_ctx.ui.gamesetup_detail_open)),
                title: _ctx.$t('game setup details')
            }, null, 10, _hoisted_15),
            (_ctx.ui.gamesetup_detail_open)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_16, [
                    _cache[9] || (_cache[9] = (0, vue_1.createElementVNode)("div", { class: "info_panel-spacing" }, null, -1)),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_17, [...(_cache[7] || (_cache[7] = [
                            (0, vue_1.createTextVNode)("Game Setup Details", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createVNode)(_component_game_setup_detail, {
                        gameOptions: _ctx.gameOptions,
                        playerNumber: _ctx.playerNumber,
                        lastSoloGeneration: _ctx.lastSoloGeneration
                    }, null, 8, ["gameOptions", "playerNumber", "lastSoloGeneration"]),
                    (0, vue_1.createElementVNode)("div", _hoisted_18, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                            class: "btn btn-lg btn-primary",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.ui.gamesetup_detail_open = false))
                        }, [...(_cache[8] || (_cache[8] = [
                                (0, vue_1.createTextVNode)("Ok", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ], 8, _hoisted_14),
        (0, vue_1.createElementVNode)("a", _hoisted_19, [
            (0, vue_1.createElementVNode)("div", _hoisted_20, [
                (0, vue_1.createElementVNode)("i", {
                    class: "sidebar_icon sidebar_icon--help",
                    title: _ctx.$t('player aid')
                }, null, 8, _hoisted_21)
            ])
        ]),
        (0, vue_1.createVNode)(_component_preferences_icon)
    ], 2));
}
